import { styled } from "styled-components";


export const PlansSection = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    flex-grow: 1;

    h5 {
        margin: 10px 0;
        font-size: 1rem;
        font-weight: 500;
    }
`

export const PlanCard = styled.div`
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    position: relative;
    border-radius: 40px;
    padding: 30px 10px 20px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    flex: 0 0 28%;
    max-width: 28%;
    width: 220px;

    img {
        height: 70px;
    }

    .plan-term {
        margin: 5px 0;
        color: #000;
        font-weight: 600;
    }

    .plan-rate {
        font-size: 1.45rem;
        color: rgb(98, 137, 233);
        font-weight: 600;
    }

    label {
        font-size: 12px;
        color:#666666;
    }

    .plan-name {
        font-size: 12px;
    }

    button {
        width: 90%;
        padding: 8px 0;
        text-align: center;
        border: none;
        background: rgb(98, 137, 233);
        color: #fff;
        border-radius: 8px;
        cursor: pointer;
        margin-top: 5px;
        white-space: nowrap;
        box-shadow: 0 4px 8px rgba(98, 137, 233, 0.1);
    }

    @media (max-width: 600px) {
        max-width: 100%;
        width: 100%;
    }
`

export const PlanTag = styled.div`
    position: absolute;
    top:5px;
    left:5px;
    border-radius: 40px;
    background: #68D4BA;
    color: #fff;
    padding: 5px 8px;
    font-size: 12px;
    box-shadow: 0 4px 8px rgba(104, 212, 186, 0.1);
`

export const Cards = styled.div`
    display: flex;
    justify-content: space-between;

    .more-button {
        background: rgb(98, 137, 233);
        color: #fff;
        border-radius: 8px;
        cursor: pointer;
        border: none;
        height: 40px;
        align-self: center;
        box-shadow: 0 4px 8px rgba(98, 137, 233, 0.1);
    }
    
    @media (max-width: 600px) {
        flex-direction: column;
        gap: 16px;
    }
`